import { useEffect, useState } from 'react';
import SideMenuWidget from '../Widget/SideMenuWidget';
import RecentPost from '../Widget/RecentPost';
import TagWidget from '../Widget/TagWidget';
import SearchWidget from '../Widget/SearchWidget';
import { useCategories } from '../Providers/CategoryContext';
const tagData = [
  {
    title: 'Business',
    url: '/',
  },
  {
    title: 'Agency',
    url: '/',
  },
  {
    title: 'Artwork',
    url: '/',
  },
  {
    title: 'Marketing',
    url: '/',
  },
  {
    title: 'Information',
    url: '/',
  },
  {
    title: 'Design',
    url: '/',
  },
  {
    title: 'Wordpress',
    url: '/',
  },
];
export default function Sidebar({ selectedCategory }) {
  const [recentPosts, setRecentPosts] = useState();
  const { categories } = useCategories()

  useEffect(() => {
      const fetchBlogs = async () => {
        try {
          const res = await fetch(`${import.meta.env.REACT_APP_CMS_URL}/items/posts?filter[status][_eq]=published&sort=-date_created&limit=4`);
          if (!res.ok) throw new Error('Failed to load posts');
          const result = await res.json()
          console.log(result.data)
          setRecentPosts(result.data || [])
        } catch (error) {
          console.error('Error fetching recent posts:', error);
          setRecentPosts([]);
        }
      }
      fetchBlogs()
  },[])

  return (
    <div className="cs-sidebar cs-right_sidebar cs-accent_5_bg_2">
      <div className="cs-sidebar_item">
        <SearchWidget title="Search" />
      </div>
      <div className="cs-sidebar_item widget_categories">
        <SideMenuWidget title="Categories" data={categories} selectedCategory={selectedCategory} />
      </div>
      <div className="cs-sidebar_item">
        <RecentPost title="Recent Posts" data={recentPosts} />
      </div>
      {/* <div className="cs-sidebar_item widget_archive">
        <SideMenuWidget title="Archives" data={archiveData} />
      </div> */}
      <div className="cs-sidebar_item widget_archive">
        <TagWidget title="Tags" data={tagData} />
      </div>
    </div>
  );
}
